// Default request timeout (ms) for the studio fetch layer. Helpers using the raw `ofetch`
// instance must pass this explicitly since they bypass the patched `globalThis.$fetch`.
export const FETCH_TIMEOUT_MS = 5000;

// Schema introspection and DDL migration can legitimately take much longer than a normal
// request on large external databases, so they need a far more generous bound than the
// default timeout (which would otherwise abort them mid-flight). Callers pass this explicitly.
export const SCHEMA_OPERATION_TIMEOUT_MS = 120_000;
